import * as React from "react";

import Config from "../../Config";

export default class FilterSearch extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            sInputValue: null,
            aMatchingNodes: null,
            nCharCounter: 0,
            bSearching: false,
            bNoResults: false
        };

        Config.getConfig();
    }

    /**
     * Getter for search phrase
     * @returns
     */
    getSearchInput = () =>
    {
        if (!this.state.sInputValue || this.state.sInputValue.length < 4)
        {
            return null;
        }
        return this.state.sInputValue;
    }

    /**
     * Setter for search phrase
     * @param {String} sInputVal 
     * @returns 
     */
    setSearchInput = (sInputVal) =>
    {
        this.state.sInputTemp = sInputVal;
        if (!sInputVal || sInputVal.length < 4)
        {
            this.state.sInputValue = null;
            return;
        }
        this.state.sInputValue = sInputVal;
    }

    /**
     * Fetch all mathing nodes
     * Search operation is triggered whenever search phrase (above 3 characters) is changed
     * @param {String} sInputVal 
     * @returns 
     */
    getSearchResult = () =>
    {
        var sInputValueState = this.getSearchInput()

        if (!sInputValueState || sInputValueState.length < 4 || !this.props.aValsToSearch || this.props.aValsToSearch.length <= 0)
        {
            if (null !== this.state.aMatchingNodes && this.props.resultsReadyCallback && typeof this.props.resultsReadyCallback === 'function')
            {
                this.state.aMatchingNodes = null;
                this.props.resultsReadyCallback();
            }
            return;
        }

        this.state.aMatchingNodes = [];
        this.props.aValsToSearch.forEach((sItem) =>
        {
            var sSearchLowerCase = sInputValueState.toLowerCase();
            var sItemLowerCase = sItem.toLowerCase();
            if (sItemLowerCase.includes(sSearchLowerCase))
            {
                var sItemToPush = sItem;
                if (this.props.aExclusions && this.props.aExclusions.length > 0)
                {
                    for (var i = 0; i < this.props.aExclusions.length; i++)
                    {
                        if (sItem.endsWith(".".concat(this.props.aExclusions[i])))
                        {
                            sItemToPush = sItemToPush.slice(0, -(this.props.aExclusions[i].length + 1));
                            if (sItemToPush.toLowerCase().includes(sSearchLowerCase))
                            {
                                break;
                            } else
                            {
                                sItemToPush = null;
                            }
                        }
                    }
                }
                if (!this.state.aMatchingNodes.includes(sItemToPush) && sItemToPush)
                {
                    this.state.aMatchingNodes.push(sItemToPush);
                }
            }
        });
        if (this.state.aMatchingNodes.length <= 0)
        {
            this.state.bNoResults = true;
        }
        if (this.props.resultsReadyCallback && typeof this.props.resultsReadyCallback === 'function')
        {
            this.props.resultsReadyCallback();
        }
    }

    /**
     * Check if provided string matches any of matchng nodes
     * @param {String} sItem 
     * @returns 
     */
    checkSearch = (sItem) =>
    {
        if (!this.state.aMatchingNodes)
        {
            return null;
        }
        try
        {
            this.state.aMatchingNodes.forEach((sMatchingNode) =>
            {
                {
                    if (sMatchingNode.includes(sItem))
                    {
                        throw true;

                        // if we want to open tree's branches only to the first occurence of search phrase
                        // var sInput = this.getSearchInput();
                        // if(sInput){
                        //     var sItemLowerCase = sItem.toLowerCase();
                        //     var sSearchLowerCase = sInput.toLowerCase();
                        //     if(!sItemLowerCase.includes(sSearchLowerCase)){
                        //         throw true;
                        //     }
                        // }
                    }
                }
            });
        } catch (aCatched)
        {
            if (true === aCatched)
            {
                return true
            }
        }
        return false;
    }

    render = () =>
    {
        const { sSearchPlaceholderTxt, sSearchIndicatorTxt, sSearchNoResultsTxt } = this.props;

        return (
            <div>
                <input
                    className="JsonTree_search"
                    type="search"
                    placeholder={sSearchPlaceholderTxt}
                    {...(this.state.bSearching ? { readOnly: true } : {})}
                    onChange={(aEvent) =>
                    {
                        if (this.state.bNoResults)
                        {
                            this.state.bNoResults = false;
                            this.setState({});
                        }
                        if (this.state.bSearching)
                        {
                            return;
                        }

                        this.state.nCharCounter++;
                        setTimeout(
                            () =>
                            {
                                this.state.nCharCounter--;
                                if (this.state.nCharCounter === 0 && this.state.sInputValue)
                                {
                                    this.state.bSearching = true;
                                    this.setState({});
                                    setTimeout(() =>
                                    {
                                        this.getSearchResult();
                                    }, 50)
                                    setTimeout(() =>
                                    {
                                        this.state.bSearching = false;
                                        this.setState({});
                                    }, 50)
                                }
                            },
                            Config.searchTypingDelay,
                            aEvent.target.value
                        );
                        this.setSearchInput(aEvent.target.value);
                    }}
                    onMouseUp={(aEvent) => // workaround to handle build in Internet Explorer behaviour
                    {
                        var sOld = aEvent.target.value;

                        if (sOld == "") return;

                        var delayedAction = (aTarget) =>
                        {
                            var sNew = aTarget.value;

                            if (sNew == "")
                            {
                                this.setSearchInput(aTarget.value);
                                this.getSearchResult()
                            }
                        }

                        setTimeout(delayedAction, 1, aEvent.target);
                    }}
                />
                {(this.state.bSearching ?
                    <label className="JsonTree_searchingLabel">
                        {sSearchIndicatorTxt}
                    </label>
                    : null
                )}
                {(this.state.bNoResults ?
                    <label className="JsonTree_searchNoResults">
                        {sSearchNoResultsTxt.replace(/%s/g, this.state.sInputValue)}
                    </label>
                    : null
                )}
            </div>
        );
    }
}